import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as jnb from "react-bootstrap";
import Swal from "sweetalert2";
import * as Yup from "yup";


import PublicHeader from "../Header/PublicHeader";
import { ERROR_MSG, MOBILE_VALIDATION, public_url } from "../CommonUtils/Validations/RegularExpAndVar";

import allowNumbersOnly from "../CommonUtils/Validations/CommonValidations";
import { CommomLoginAunthenticatePost } from "../CommonUtils/CommonAxios/CommonAxios";
import { config } from "../CommonUtils/CommonUrl/CommonUrls";
import Sweetalert from "../CommonUtils/CommonPopupAndAlerts/SweetAlerts";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function Forgotpassword() {

    const [showData, setData] = useState(false);
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(30);
        const [showSendOTP, setShowSendOTP] = useState(true);
      const [timerActive, setTimerActive] = useState(false);

    const userValidations = Yup.object().shape({
        phoneno: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid Phone Number"),
        otp: Yup.string().required(ERROR_MSG),
        pwd: Yup.string().required(ERROR_MSG).matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ),
        repwd: Yup.string().oneOf([Yup.ref("pwd"), null], "Passwords must match").required(ERROR_MSG),
    })
    const phoneRegex = /^[6-9]{1}[0-9]{9}$/;
    const formIk = useFormik({
        initialValues: {
            phoneno: '',
            pwd: '',
            repwd: "",
            otp:'',
        },


        onSubmit: (values) => {
            // alert(JSON.stringify(values));
            submitDetailsThree(values);

            // onSubmit: (values, {resetForm}) => {
            //     alert(JSON.stringify(values));
            //     submitDetailsone(values, resetForm);

            //console.log("values>>>>>", values);
        },
        validationSchema: userValidations,
    })
    function Otp() {
        if (formIk.values.phoneno !== "") {
            if (!phoneRegex.test(formIk.values.phoneno)) {
                Sweetalert('Please enter a valid 10-digit Mobile number (starting with 6-9)', 'warning');
                return false;

            };
            setMinutes(3);
            setSeconds(0);
            return true;
        }
        else { Sweetalert('Please Check Whether you have entered All Fields or not', 'warning') }
        return false;
    }


    const submitDetailsTwo = async () => {
        try {
            let url = config.url.BOC_URL + public_url + "getotp/" + formIk.values.phoneno;
            const res = await CommomLoginAunthenticatePost(url);
            if (res?.data?.scode === "01") {
                Sweetalert("OTP Sent", "success")
                setData(true)
                setShowSendOTP(false);
                setMinutes(3);
            setSeconds(0);
            setTimerActive(true);
            }
            else {
                Sweetalert(res?.data?.sdesc, "error").then(() => {
                    setData(false);
                    formIk.setFieldValue("phoneno", "")
                    setShowSendOTP(true);
                })
            }

        } catch (e) {
            console.log("exception at catch block ===>" + e);
        }
    };

    let navigate = useNavigate()
    const submitDetailsThree = async (values) => {
        try {
            let url = config.url.BOC_URL + public_url + "getforgotpassword";
            const res = await CommomLoginAunthenticatePost(url, values);

            if (res?.data?.scode === "01") {
                Sweetalert("Your Password is Successfully Updated", "success").then(() => {
                    navigate("/login");

                })
            }
            else {
                Sweetalert(res?.data?.sdesc, "warning").then(() => {
                    //  formIk.setFieldValue("repwd","");
                    //   formIk.setFieldValue("pwd","");
                    formIk.setFieldValue("otp", "");

                })
            }

        } catch (e) {
            console.log("exception at catch block ===>" + e);
        }
    };


    //     let otpAttemptCount = 0;
    // let otpBlockedUntil = null; // timestamp for blocking

    // const submitDetailsThree = async (values) => {
    //     const now = new Date();

    //     // Check if user is currently blocked
    //     if (otpBlockedUntil && now < otpBlockedUntil) {
    //         Sweetalert("Too many attempts. Please try again after 10 minutes.", "error");
    //         return; // stop submission
    //     }

    //     try {
    //         let url = config.url.BOC_URL + public_url + "getforgotpassword";
    //         const res = await CommomLoginAunthenticatePost(url, values);

    //         if (res?.data?.scode === "01") {
    //             // Reset counter on success
    //             otpAttemptCount = 0;
    //             Sweetalert("Your Password is Successfully Updated", "success").then(() => {
    //                 navigate("/login");
    //             });
    //         } else {
    //             otpAttemptCount += 1; // Increment failed attempts

    //             // Check if failed 4 times
    //             if (otpAttemptCount >= 4) {
    //                 otpBlockedUntil = new Date(now.getTime() + 10 * 60000); // Block for 10 min
    //                 Sweetalert("Too many attempts. Please try again after 10 minutes.", "error");
    //             } else {
    //                 Sweetalert(res?.data?.sdesc, "warning").then(() => {
    //                     formIk.setFieldValue("repwd", "");
    //                     formIk.setFieldValue("pwd", "");
    //                     formIk.setFieldValue("otp", "");
    //                 });
    //             }
    //         }
    //     } catch (e) {
    //         console.log("exception at catch block ===>", e);
    //     }
    // };

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                    setTimerActive(false);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [timerActive, minutes,seconds]);

    // const resendOTP = () => {
    //     setMinutes(3);
    //     setSeconds(0);
    // };

    const resendOTP = async () => {
        try {
            let url = config.url.BOC_URL + public_url + "getotp/" + formIk.values.phoneno;
            const res = await CommomLoginAunthenticatePost(url);

            if (res?.data?.scode === "01") {
                Sweetalert("OTP Resent", "success");
                setMinutes(3);
                setSeconds(0);
                 setTimerActive(true);
            } else {
                Sweetalert(res?.data?.sdesc, "error");
                formIk.setFieldValue("otp", "")
            }
        } catch (e) {
            console.log("exception at catch block ===>", e);
        }
    };
    const [showPassword, setShowPassword] = useState(false);

    return (


        <>
            <PublicHeader />
            <div className="main_section">  </div>
            <jnb.Container >
                <jnb.Row >
                    <jnb.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>&nbsp;</jnb.Col>
                    <jnb.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                        <div className="login-card mt-0 pt-3">
                            <FormikProvider value={formIk}>
                                <jnb.Form onSubmit={formIk.handleSubmit} onChange={formIk.handleChange}>
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 style={{ fontSize: '30px' }}> Forgot Password</h1>
                                    </div>
                                    <jnb.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} className="jumbotron mt20 form-card-jnb pb-3 bg-white" style={{ marginTop: "5px" }}>
                                        {/* <jnb.Container >
                                        <jnb.Row className="px-2 pt-3">

                                            <jnb.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                                <jnb.InputGroup >
                                                    
                                                    <span className="mb-5 mb-md-2 field-mandatory" ><b>Mobile No</b></span>
                                                    <Field type="text" name="phoneno" className="form-control w-100 nb-1" maxLength="12" />
                                                    <ErrorMessage name="phoneno" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                                <jnb.InputGroup>
                                                    <div className='d-flex flex-row justify-content-start px-4'>
                                                        
                                                        <button type="button" className="btn btn-primary" >Send OTP</button>
                                                    </div>
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                        </jnb.Row>

                                        <br></br>
                                        <jnb.Row>
                                            <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                <div className='d-flex flex-row justify-content-start'>
                                                    {seconds > 0 || minutes > 0 ? (
                                                        <p>
                                                            Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                                                            {seconds < 10 ? `0${seconds}` : seconds}
                                                        </p>
                                                    )
                                                        : (
                                                            <p>Didn't recieve code?</p>
                                                        )
                                                    }
                                                </div>
                                            </jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                <div className='d-flex flex-row justify-content-end px-2'>
                                                    <button disabled={seconds > 0 || minutes > 0} style={{ color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630", }}

                                                    >
                                                        Resend OTP
                                                    </button>
                                                </div>
                                            </jnb.Col>
                                        </jnb.Row>
                                        <jnb.Row>
                                           
                                            <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                <jnb.InputGroup>
                                                    <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Password</b></span>
                                                    <Field type="password" name="pwd" className="form-control w-100 nb-1" maxLength="12" placeholder="Enter Password" />
                                                    <ErrorMessage name="pwd" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                          
                                            <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                <jnb.InputGroup>
                                                    <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Confirm Password</b></span>
                                                    <Field type="password" name="repwd" className="form-control w-100 nb-1" maxLength="12" placeholder="Confirm Password" />
                                                    <ErrorMessage name="repwd" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                        </jnb.Row>
                                        <br></br>
                                        <br></br>
                                        <jnb.Row>
                                            <jnb.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>

                                                <div className='d-flex flex-row justify-content-end px-3'>
                                                    <jnb.Button type="submit" className="btn btn-success" >Submit</jnb.Button>
                                                </div>

                                            </jnb.Col>
                                        </jnb.Row>
                                    </jnb.Container> */}

                                        <jnb.Row className=" pt-3 mb-3">
                                            <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                            <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                <jnb.InputGroup >
                                                    <span className="mb-5 mb-md-2 field-mandatory" ><b>Mobile No</b></span>
                                                    <Field type="text" name="phoneno" className="form-control w-100 nb-1" maxLength="12" autoComplete="off" />
                                                    <ErrorMessage name="phoneno" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col>
                                            {showSendOTP && (
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5} className="pt-4 mt-1">
                                                    <jnb.InputGroup>
                                                        <div className='d-flex flex-row justify-content-start'>
                                                            <button type="button" className="btn btn-primary" onClick={() => {
                                                                const isValid = Otp(); if (isValid) {
                                                                    submitDetailsTwo(); // only call if inputs are valid
                                                                }
                                                            }} >Send OTP</button>
                                                        </div>
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                            )}
                                        </jnb.Row>
                                        {showData === true && (
                                            <>
                                                <jnb.Row>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                        <jnb.InputGroup>
                                                            <span className="mb-5 mb-md-2 field-mandatory px-2"><b>OTP</b></span>
                                                            <Field type="text" name="otp" maxLength="6" className="form-control w-100 nb-1 px-2" placeholder="Enter OTP Here" autoComplete="off" onKeyPress={(e) => { allowNumbersOnly(e) }} />
                                                            <ErrorMessage name="otp" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                </jnb.Row>
                                                <br></br>
                                                <jnb.Row>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                        <div className='d-flex flex-row justify-content-start'>
                                                           {timerActive ? (
                                                                <p>
                                                                    Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                                                                    {seconds < 10 ? `0${seconds}` : seconds}
                                                                </p>
                                                            )
                                                                : (
                                                                    <p>Didn't recieve code?</p>
                                                                )
                                                            }
                                                        </div>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                                        <div className='d-flex flex-row justify-content-end px-2'>
                                                            <button
                                                                disabled={timerActive}
                                                                style={{
                                                                    color: timerActive ? "#DFE3E8" : "#FF5630"
                                                                }}
                                                                onClick={resendOTP}
                                                            >
                                                                Resend OTP
                                                            </button>
                                                        </div>
                                                    </jnb.Col>
                                                </jnb.Row>
                                                <br></br>
                                                <jnb.Row className="mb-3">
                                                    <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                        <jnb.InputGroup>
                                                            <div style={{ position: "relative", width: "100%" }}>
                                                                <span className="mb-5 mb-md-2 field-mandatory"><b>Password</b></span>
                                                                <Field type={showPassword ? "text" : "password"} autoComplete="new-password" name="pwd" className="form-control w-100 nb-1" maxLength="12" placeholder="Enter Password" />
                                                                <span
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "10px",
                                                                        top: "65%",
                                                                        transform: "translateY(-50%)",
                                                                        cursor: "pointer",
                                                                        color: "#666",
                                                                    }}
                                                                >
                                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                                </span>
                                                            </div>
                                                            <ErrorMessage name="pwd" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                        <jnb.InputGroup>
                                                            <div style={{ position: "relative", width: "100%" }}>
                                                                <span className="mb-5 mb-md-2 field-mandatory"><b>Confirm Password</b></span>
                                                                <Field type={showPassword ? "text" : "password"} name="repwd" className="form-control w-100 nb-1" maxLength="12" placeholder="Confirm Password" autoComplete="off" />
                                                                <span
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "10px",
                                                                        top: "65%",
                                                                        transform: "translateY(-50%)",
                                                                        cursor: "pointer",
                                                                        color: "#666",
                                                                    }}
                                                                >
                                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                                </span>
                                                            </div>
                                                            <ErrorMessage name="repwd" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                </jnb.Row>

                                                <jnb.Row>
                                                    <jnb.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                                        <div className='d-flex flex-row justify-content-end mt-3'>
                                                            <jnb.Button type="submit" className="btn btn-success">Submit</jnb.Button>
                                                        </div>

                                                    </jnb.Col>
                                                </jnb.Row>
                                            </>
                                        )}
                                    </jnb.Col>

                                </jnb.Form>
                            </FormikProvider>
                        </div>

                    </jnb.Col>
                    <jnb.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>&nbsp;</jnb.Col>
                </jnb.Row>
            </jnb.Container>
        </>
    );
}
